/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import { Box, InputAdornment } from "@mui/material";
import InputBase from "@mui/material/InputBase";
import clsx from "clsx";
import { MagnifyingGlassIcon, XIcon } from "../../FontAwesome";
import { translationKeys, useTranslation } from "./../../Internationalisierung/i18nBasis";
import CommandBarSearchInputModel from "./CommandBarSearchInputModel";
import CommandBarSearchInputProps from "./CommandBarSearchInputProps";
import "./CommandBarSearchInput.scss";

export default function CommandBarSearchInput(props: CommandBarSearchInputProps) {
    const vm = new CommandBarSearchInputModel(props);
    const { t } = useTranslation();

    return (
        <Box component="form" className={clsx(vm.formClassName, props.className)} sx={props.sx} onSubmit={vm.suchen}>
            <InputBase
                className="lan-commandbarsearchinput__inputbase"
                type="text"
                value={vm.suchbegriff}
                onChange={vm.aendereSuchbegriff}
                placeholder={t(translationKeys.commandBarSearchInput.suchbegriffEingeben)}
                autoFocus={props.autoFocus}
                inputProps={{
                    className: "lan-commandbarsearchinput__inputbase__input",
                }}
                inputRef={props.inputRef}
                startAdornment={
                    <InputAdornment
                        className="lan-commandbarsearchinput__inputbase__inputadornment--start"
                        onClick={vm.suchen}
                        position="start"
                    >
                        <MagnifyingGlassIcon className="lan-commandbarsearchinput__inputbase__inputadornment__icon" fontSize="small"/>
                    </InputAdornment>
                }
                endAdornment={
                    vm.istLeerenSichtbar && (
                        <InputAdornment
                            className="lan-commandbarsearchinput__inputbase__inputadornment--end"
                            onClick={vm.leeren}
                            position="end"
                        >
                            <XIcon className="lan-commandbarsearchinput__inputbase__inputadornment__icon" />
                        </InputAdornment>
                    )
                }
            />
        </Box>
    );
}
